'use strict';

/* globals document, $, window, config, socket */

var userProfileExtended = {};

$(document).ready(function () {
	userProfileExtended.changeMenuLinkToExtendedSettings();
	userProfileExtended.addRedirectAfterLogout();
	userProfileExtended.addToogleBehavior();
	userProfileExtended.updateNotificationsCount();
});

userProfileExtended.changeMenuLinkToExtendedSettings = function () {
	if (!$('[component="header/usercontrol"]').length) {
		return;
	}

	$('a[component="header/profilelink/edit"]').parent().remove();

	var settingsLink = $('a[component="header/profilelink/settings"]');
	settingsLink.attr('href', settingsLink.attr('href').replace('settings', 'extended-settings'));
};

userProfileExtended.addRedirectAfterLogout = function () {
	$(window).on('action:app.loggedOut', function () {
		window.location.href = config.relative_path + '/';
	});
};

userProfileExtended.addToogleBehavior = function () {
	$('[data-toggle="collapse"]').on('click', function () {
		$(this).children('span').each(function (index, el) {
			if ($(el).hasClass('d-none')) $(el).removeClass('d-none');
			else $(el).addClass('d-none');
		});
	});
};

userProfileExtended.updateNotificationsCount = function () {
	require(['notifications', 'components'], function (Notifications, components) {
		socket.emit('notifications.getCount', function (err, count) {
			if (err) {
				throw err;
			}

			Notifications.updateNotifCount(count);
		});

		socket.emit('user.getUnreadChatCount', function (err, count) {
			if (err) {
				throw err;
			}

			components.get('chat/icon')
				.toggleClass('unread-count', count > 0)
				.attr('data-content', count > 99 ? '99+' : count);
		});
	});
};
